export const IS_TEST = import.meta.env.MODE === "test";
export const IS_DEV = import.meta.env.DEV;
export const IS_PROD = import.meta.env.PROD;
export const LOG_DEBUG = import.meta.env.VITE_LOG_DEBUG || "";
export const LOG_LEVEL = (import.meta.env.VITE_LOG_LEVEL || "info") as
  | "debug"
  | "info"
  | "warn"
  | "error";
